import { map } from 'lodash/fp';
import { pickBy, isEmpty, reduce, has } from 'lodash';

import { isTableType } from 'constants/chart-roles';
import { attemptCast } from 'utils/bson';

/**
 * This step is required while charts do not have handles for more complicated return types
 * Required to make all the charts behave as before, while allowing more complicated values for table
 * @param  {Object} stageData   object containing documents returned from the agg pipeline, as well as metadata about the chart type
 * @return {Object}            object containing documents with the values simplified to their label form
 */
function chartValueSimplification(stageData) {
  const { chartType, channels } = stageData.environment;
  if (isTableType(chartType)) {
    return {};
  }

  const applicableChannels = pickBy(channels, chan => chan.isBinning);

  if (isEmpty(applicableChannels)) {
    return {};
  }

  const channelsToFlatten = Object.keys(applicableChannels);

  // for every document, check if any value has a 'display' property, and then use it.
  // otherwise, leave the value as-is
  const documents = map(doc => {
    return reduce(
      channelsToFlatten,
      (acc, channel) => ({
        ...acc,
        ...(has(doc[channel], 'display')
          ? { [channel]: doc[channel].display }
          : {}),
        ...(has(doc[channel], 'raw')
          ? { [`${channel}_raw`]: attemptCast(doc[channel].raw) }
          : {}),
      }),
      doc
    );
  }, stageData.documents);

  return { documents };
}

export default {
  input: ['environment.chartType', 'environment.channels', 'documents'],
  fn: chartValueSimplification,
};
export { chartValueSimplification };
